import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">La promenado</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        La plum’ sur ĉapelo kliniĝis lante, <br/>
        Pro lia rigardo premiĝis kor’. <br/>
        Anim’ sopiris, mem ne sciante <br/>
        De kie venis la angor’.
      </p>

      <p class="poem-block mb-3">
        Ĉirkaŭe tristas vesper’ pariza. <br/>
        Sub nebuloza firmament’ <br/>
        Pentrita sur folio griza <br/>
        Arbar’ Bulona dormas sen vent’.
      </p>

      <p class="poem-block mb-3">
        Siring’ odoras kaj benzino, <br/>
        Silent’ gravedas per pean’. <br/>
        Denove tuŝis al mia sino <br/>
        Sentrema preskaŭ, lia man’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Lundo, nokto, la dudek unua…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Nokto. Lundo. La dudek unua. <br/>
        Peterburg’ en malhela aer’. <br/>
        Ja elpensis fripon’ cerbotrua, <br/>
        Ke ekzistas la am’ sur la ter’.
      </p>

      <p class="poem-block mb-3">
        Kaj pro pigro aŭ simpla enuo <br/>
        Ĉiuj kredis, obeis kaj jen: <br/>
        Ili revas pri la rendevuo <br/>
        Kaj disiĝon evitas kun pen’.
      </p>

      <p class="poem-block mb-3">
        Sed kelkiuj posedas misteron, <br/>
        La benitaj en sia silent’… <br/>
        Mi hazarde malkovris la veron, <br/>
        Kaj ĝis nun dolorigas min sent’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Kuraĝo</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ni scias, pro kio nin pesas destin’ <br/>
        Kaj kio okazas hodiaŭ. <br/>
        Kuraĝon postulas la sort’ kun obstin’, <br/>
        Kuraĝ’ nin forlasos neniam. <br/>
        Ne timas ni kuglojn, malgraŭ vivovol’, <br/>
        Senhejmo ne estas defia, <br/>
        Sed vin ni konservos, ho rusa parol’, <br/>
        Ho vorto potenca Rusia! <br/>
        Liberan kaj puran elportos tra fajr’ <br/>
        Kaj savos por nepoj de la akapar’ <br/>
        Por ĉiam.
      </p>
      <p class="poem-block poem-date">1942</p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Anna Ahmatova'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;